import { CheckOutlined, ClearOutlined, CloseOutlined } from "@ant-design/icons";
import { Button, Col, Popconfirm, Row, Space, Table, Typography, notification } from "antd";
import { useDeleteQuestionsMutation, useGetQuestionsQuery } from "api";
import { OBJ_COLOR, USER_ADMIN } from "commons/constants";
import { Question as QuestionsModel } from "models";
import { Template } from "./Template";
import { useAppSelector } from "store";
const { Text, Title } = Typography;

export const Question = () => {
	const user = useAppSelector((state) => state.user);

	const { data: questions, isLoading } = useGetQuestionsQuery(undefined);
	const [deleteQuestions] = useDeleteQuestionsMutation();

	const handleOnClickDeleteQuestions = async () => {
		try {
			await deleteQuestions(undefined).unwrap();
			notification.success({
				message: "Success",
			});
		} catch (error: any) {
			notification.error({
				message: error.data.message,
			});
		}
	};

	return (
		<>
			<Row gutter={[0, 20]}>
				<Col span={24}>
					<Title style={{ color: OBJ_COLOR.SUCCESS, margin: 0 }} level={3}>
						Danh sách câu hỏi
					</Title>
				</Col>
				<Col span={24}>
					<Space>
						<Template nameSheet={"Bộ câu hỏi tiếng Việt"} header={["stt", "category", "question", "type", "answer", "isRequired"]} />
						{USER_ADMIN.includes(user?.id as string) && (
							<Popconfirm disabled={!questions?.length ? true : false} placement="rightBottom" title="Are you sure clear data ?" onConfirm={handleOnClickDeleteQuestions}>
								<Button icon={<ClearOutlined />} danger disabled={!questions?.length ? true : false}>
									Clear Data
								</Button>
							</Popconfirm>
						)}
					</Space>
				</Col>
				<Col span={24}>
					<Table
						pagination={{
							showSizeChanger: true,
							hideOnSinglePage: true,
						}}
						dataSource={questions?.map((item, key) => ({ ...item, key: key + 1 }))}
						loading={isLoading}
						scroll={{ x: true }}
						style={{ whiteSpace: "nowrap" }}>
						<Table.Column title="STT" dataIndex="key" />
						<Table.Column<QuestionsModel>
							title="Phân mục"
							render={(_, record) => {
								return record?.category;
							}}
						/>
						<Table.Column<QuestionsModel>
							title="Câu hỏi "
							render={(_, record) => {
								return <Space style={{ width: 400, whiteSpace: "break-spaces" }}>{record?.question}</Space>;
							}}
						/>
						<Table.Column<QuestionsModel>
							title="Câu trả lời"
							render={(_, record) => {
								const data = record?.answer.split("\n");
								return (
									<Space direction="vertical">
										{data.map((item, key) => (
											<Text key={key}>{item}</Text>
										))}
									</Space>
								);
							}}
						/>
						<Table.Column<QuestionsModel>
							title="Phân loại"
							render={(_, record) => {
								return record?.type;
							}}
						/>
						<Table.Column<QuestionsModel>
							title="Yêu cầu bắt buộc"
							align="center"
							render={(_, record) => {
								return record?.isRequired ? <CheckOutlined style={{ color: OBJ_COLOR.SUCCESS }} /> : <CloseOutlined style={{ color: OBJ_COLOR.DANGER }} />;
							}}
						/>
					</Table>
				</Col>
			</Row>
		</>
	);
};
